import React, { useState, useMemo } from 'react';
import styles from './IdentityValidationSection.module.scss';
import IdentityTable from './IdentityTable.tsx';
import IdentityModal from './IdentityModal.tsx';
import Pagination from '../Shared/Pagination.tsx';
import EmptyState from '../Shared/EmptyState.tsx';
import LoadingSpinner from '../Shared/LoadingSpinner.tsx';

interface IdentityValidationSectionProps {
  users: any[];
  loading: boolean;
  onValidate: (userId: string, isValid: boolean) => void;
}

const ITEMS_PER_PAGE = 5;

const IdentityValidationSection: React.FC<IdentityValidationSectionProps> = ({
  users,
  loading,
  onValidate
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);

  const totalPages = useMemo(() => {
    return Math.ceil(users.length / ITEMS_PER_PAGE);
  }, [users]);

  const paginatedUsers = useMemo(() => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    return users.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  }, [currentPage, users]);

  const openModal = (user: any) => {
    setSelectedUser(user);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedUser(null);
  };

  if (loading) {
    return <LoadingSpinner message="Cargando usuarios..." />;
  }

  if (!users || users.length === 0) {
    return (
      <EmptyState
        title="No hay validaciones pendientes"
        message="Todos los usuarios han sido validados"
      />
    );
  }

  return (
    <div className={styles.section}>
      <div className={styles.header}>
        <h2 className={styles.title}>Validación de Identidad</h2>
        <span className={styles.count}>
          {users.length} {users.length === 1 ? 'usuario' : 'usuarios'} pendiente{users.length !== 1 ? 's' : ''}
        </span>
      </div>

      <IdentityTable
        users={paginatedUsers}
        onViewImages={openModal}
        onValidate={onValidate}
      />

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />

      {modalOpen && selectedUser && (
        <IdentityModal
          user={selectedUser}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default IdentityValidationSection;

